<template>
  <div>
    <auto-suggest
      class="flex-grow-1"
      icon="mdi-text-box-search-outline"
      :showAddButton="false"
      v-model="selectedStudent"
      @search="lookupStudent"
      @input="studentChanged"
      suggestionText="name"
      suggestionValue="id"
      return-object
      label="Lookup student using first or last name"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import AutoSuggest from "@/components/common/AutoSuggest.vue";
export default {
  props: {
    value: {
      type: [Number, String, Object],
      required: false,
      default: null
    }
  },
  data: () => {
    return { 
      selectedStudent: null
    }
  },
  created(){
    this.selectedStudent = this.value;
  },
  computed: {
    ...mapGetters("student", ["studentProcessed", "getStudents"])
  },
  methods: {
    ...mapActions("student", ["deleteStudent", "fetchStudents"]),

    lookupStudent(query, callback) {
      const params = {
        page: 0,
        size: 10000,
        sort: "firstName"
      };
      if (query) {
        params["firstName"] = query;
        params["lastName"] = query;
      }
      this.fetchStudents(params)
        .then(response => {
          if (response) {
            const students = response.content;
            if (students && students.length > 0) {
              students.forEach(s => {
                s.name = `${s.firstName} - ${s.lastName}`;
              });
            }
            callback(students);
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
          callback([]);
        });
    },
    studentChanged(student){
      this.$emit('input', student);
    }
  },
  components: { AutoSuggest }
};
</script>

<style></style>
